import TextField from './text-field'

TextField.install = (Vue) => {
  Vue.component(TextField.name, TextField)
}

export default TextField



// WEBPACK FOOTER //
// ./src/bcq-ui/components/text-field/index.js